import {
  components,
  type OptionProps,
  type SingleValueProps,
} from 'react-select';

export type RuleSelectOption = { value: string; label: string };

export function TooltipOption(props: OptionProps<RuleSelectOption, false>) {
  return (
    <components.Option {...props}>
      <span className="block truncate" title={props.data.label}>
        {props.children}
      </span>
    </components.Option>
  );
}

export function TooltipSingleValue(
  props: SingleValueProps<RuleSelectOption, false>,
) {
  return (
    <components.SingleValue {...props}>
      <span className="block truncate" title={props.data.label}>
        {props.children}
      </span>
    </components.SingleValue>
  );
}
